var r=/\s/;var t=function(t){for(var a=t.length;a--&&r.test(t.charAt(a)););return a};export{t as default};
